// extracted by mini-css-extract-plugin
module.exports = {"aboutUs":"aboutUs_aboutUs_Xe4s6","show":"aboutUs_show_3dV7J","hide":"aboutUs_hide_1wpGa","scrollBar":"aboutUs_scrollBar_19VeE","bar":"aboutUs_bar_1FE2C"};